import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';

import { load, connectMoreNews } from 'modules/Common/reducers/morenews';
import { loadMediaForArticles } from 'modules/Common/reducers/media';

import HomeTipsSection from '../components/TipsSection';

const TIPS_PATH = '/football/tips-centre';

@layoutAsyncConnect(
  "FootballTips",
  [{
    dispatch: () => load(TIPS_PATH, 3),
    state: connectMoreNews,
    then: ({dispatch, state, result: {articles}}) => loadMediaForArticles(state, dispatch, articles)
  }]
)
export default class FootballTips extends Component {
  static propTypes = {
    plainTitle: PropTypes.bool,
    news: PropTypes.object
  };

  render() {
    const {
      news: {
        [TIPS_PATH]: {
          articles: tipsItems = []
        } = {}
      } = {},
      plainTitle
    } = this.props;

    const componentData = {
      plainTitle,
      sectionLabel: "Football",
      sectionLink: "/football",
      additionalTipsLinks: [
        {text: "All Football Tips", href: "/football/tips-centre"},
        {text: "Tips & Previews", href: "/football"}
      ],
      tipsItems: tipsItems.slice(0, 3)
    };

    return (
      <HomeTipsSection {...componentData} />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/FootballTips.js